export default {
  common: {
    back: 'Indietro',
    contact: 'Contatto',
    email: 'support@wedora.fr',
    privacyEmail: 'privacy@wedora.fr',
  },
  termsOfService: {
    title: 'Termini di Servizio',
    sections: {
      introduction: {
        title: '1. Introduzione',
        content: 'Benvenuto su Wedora. Utilizzando il nostro servizio, accetti di rispettare questi termini di servizio. Ti preghiamo di leggerli attentamente prima di utilizzare la nostra piattaforma.',
      },
      description: {
        title: '2. Descrizione del Servizio',
        content: 'Wedora è una piattaforma di pianificazione matrimoniale che consente alle coppie di:',
        features: [
          'Gestire la loro lista degli invitati',
          'Monitorare il loro budget',
          'Organizzare le loro attività',
          'Creare il loro sito web di matrimonio',
          'Comunicare con i loro fornitori',
        ],
      },
      accounts: {
        title: '3. Account Utente',
        content: 'Per utilizzare Wedora, devi creare un account. Sei responsabile del mantenimento della riservatezza delle tue credenziali e di tutte le attività che si verificano sotto il tuo account.',
      },
      usage: {
        title: '4. Utilizzo del Servizio',
        content: 'Utilizzando il nostro servizio, accetti di:',
        rules: [
          'Non utilizzare il servizio per scopi illegali',
          'Non tentare di compromettere la sicurezza del servizio',
          'Non condividere contenuti inappropriati o offensivi',
          'Rispettare i diritti degli altri utenti',
        ],
      },
      intellectual: {
        title: '5. Proprietà Intellettuale',
        content: 'Tutti i contenuti su Wedora, inclusi ma non limitati a testi, grafica, loghi e codice sorgente, sono proprietà di Wedora o dei suoi partner e sono protetti dalle leggi sulla proprietà intellettuale.',
      },
      modifications: {
        title: '6. Modifiche ai Termini',
        content: 'Ci riserviamo il diritto di modificare questi termini in qualsiasi momento. Le modifiche entreranno in vigore una volta pubblicate sul sito. Il tuo uso continuato del servizio dopo queste modifiche costituisce la tua accettazione dei nuovi termini.',
      },
      contact: {
        title: '7. Contatto',
        content: 'Per qualsiasi domanda riguardante questi termini di servizio, ti preghiamo di contattarci all\'indirizzo: support@wedora.fr',
      },
    },
  },
  privacyPolicy: {
    title: 'Informativa sulla Privacy',
    sections: {
      introduction: {
        title: '1. Introduzione',
        content: 'Su Wedora, diamo grande importanza alla protezione dei tuoi dati personali. Questa informativa sulla privacy spiega come raccogliamo, utilizziamo e proteggiamo le tue informazioni.',
      },
      dataCollection: {
        title: '2. Raccolta Dati',
        content: 'Raccogliamo le seguenti informazioni:',
        types: [
          'Informazioni del profilo (nome, cognome, email)',
          'Informazioni sul tuo matrimonio (data, luogo)',
          'Lista degli invitati',
          'Informazioni sul budget',
          'Preferenze di personalizzazione',
        ],
      },
      dataUsage: {
        title: '3. Utilizzo dei Dati',
        content: 'Utilizziamo i tuoi dati per:',
        purposes: [
          'Fornire e migliorare i nostri servizi',
          'Personalizzare la tua esperienza',
          'Comunicare con te riguardo al tuo account',
          'Inviare notifiche importanti',
          'Analizzare e migliorare i nostri servizi',
        ],
      },
      dataProtection: {
        title: '4. Protezione dei Dati',
        content: 'Implementiamo misure di sicurezza appropriate per proteggere i tuoi dati contro qualsiasi accesso, modifica, divulgazione o distruzione non autorizzati. I tuoi dati sono memorizzati su server sicuri e sono crittografati durante la trasmissione.',
      },
      dataSharing: {
        title: '5. Condivisione dei Dati',
        content: 'Non vendiamo mai i tuoi dati personali a terze parti. Possiamo condividere alcune informazioni con i nostri fornitori di servizi che ci aiutano a gestire la nostra piattaforma, soggetti a rigorosi obblighi di riservatezza.',
      },
      rights: {
        title: '6. I Tuoi Diritti',
        content: 'In conformità con il GDPR, hai i seguenti diritti:',
        list: [
          'Diritto di accesso ai tuoi dati',
          'Diritto di rettifica',
          'Diritto alla cancellazione',
          'Diritto alla portabilità dei dati',
          'Diritto di opporsi al trattamento',
        ],
      },
      cookies: {
        title: '7. Cookie',
        content: 'Utilizziamo i cookie per migliorare la tua esperienza sulla nostra piattaforma. Puoi controllare l\'utilizzo dei cookie tramite le impostazioni del tuo browser.',
      },
      contact: {
        title: '8. Contatto',
        content: 'Per qualsiasi domanda riguardante la nostra informativa sulla privacy o per esercitare i tuoi diritti, ti preghiamo di contattarci all\'indirizzo: privacy@wedora.fr',
      },
    },
  },
}; 